<app-action-more [fontAwesomeIconClass]="'fa-solid fa-trash'" [actionLabel]="'Delete Folder'" (click)="onSelected()" ></app-action-more>
